module.exports = __webpack_public_path__ + "static/media/video_preview_default.66b7db62.jpg";